<template>
  <CSidebarNav class="sidebar-slider" :accordion="false">
    <CNavItem>
      <router-link to="/dashboard" class="nav-link">
        <span class="material-symbols-outlined nav-icon">rocket_launch</span>
        <span class="link-text">{{ $t('sidebar.Space') }}</span>
      </router-link>
    </CNavItem>

    <CNavGroup :visible="isOpenGroup(['/leads', '/clients', '/projects', '/crm/client-documents'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">lightbulb</span>
        <span class="link-text">{{ $t('sidebar.crm') }}</span>
      </template>
      <CNavItem>
        <router-link to="/leads" class="nav-link">
          <span class="material-symbols-outlined nav-icon">person_add</span>
          <span class="link-text">{{ $t('sidebar.leadsManagement') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/clients" class="nav-link">
          <span class="material-symbols-outlined nav-icon">group</span>
          <span class="link-text">{{ $t('sidebar.clients') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/projects" class="nav-link">
          <span class="material-symbols-outlined nav-icon">folder</span>
          <span class="link-text">{{ $t('sidebar.projects') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/crm/client-documents" class="nav-link">
          <span class="material-symbols-outlined nav-icon">description</span>
          <span class="link-text">{{ $t('sidebar.clientsDocuments') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavGroup :visible="isOpenGroup(['/invoicing', '/expenses', '/income'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">attach_money</span>
        <span class="link-text">{{ $t('sidebar.finances') }}</span>
      </template>
      <CNavItem>
        <router-link to="/invoicing" class="nav-link">
          <span class="material-symbols-outlined nav-icon">receipt</span>
          <span class="link-text">{{ $t('sidebar.invoicing') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/expenses" class="nav-link">
          <span class="material-symbols-outlined nav-icon">paid</span>
          <span class="link-text">{{ $t('sidebar.expenses') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/income" class="nav-link">
          <span class="material-symbols-outlined nav-icon">paid</span>
          <span class="link-text">{{ $t('sidebar.income') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavItem>
      <router-link to="/worktime-report" class="nav-link">
        <span class="material-symbols-outlined nav-icon">description</span>
        <span class="link-text">{{ $t('sidebar.reports') }}</span>
      </router-link>
    </CNavItem>

    <CNavItem>
      <router-link to="/attendance" class="nav-link">
        <span class="material-symbols-outlined nav-icon">schedule</span>
        <span class="link-text">{{ $t('sidebar.attendance') }}</span>
      </router-link>
    </CNavItem>

    <CNavItem>
      <router-link to="/team" class="nav-link">
        <span class="material-symbols-outlined nav-icon">groups</span>
        <span class="link-text">{{ $t('sidebar.team') }}</span>
      </router-link>
    </CNavItem>

    <CNavItem>
      <router-link to="/wiki" class="nav-link">
        <span class="material-symbols-outlined nav-icon">menu_book</span>
        <span class="link-text">{{ $t('sidebar.wiki') }}</span>
      </router-link>
    </CNavItem>

    <CNavItem>
      <router-link to="/tasks" class="nav-link">
        <span class="material-symbols-outlined nav-icon">view_kanban</span>
        <span class="link-text">{{ $t('sidebar.tasks') }}</span>
      </router-link>
    </CNavItem>

    <!--
    <CNavItem>
      <router-link to="/estimations" class="nav-link">
        <span class="material-symbols-outlined nav-icon">calculate</span>
        <span class="link-text">{{ $t('sidebar.estimations') }}</span>
      </router-link>
    </CNavItem>
    -->

    <CNavItem>
      <router-link to="/inventory" class="nav-link">
        <span class="material-symbols-outlined nav-icon">warehouse</span>
        <span class="link-text">{{ $t('sidebar.inventory') }}</span>
      </router-link>
    </CNavItem>

    <CNavGroup :visible="isOpenGroup(['/hr/'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">supervisor_account</span>
        <span class="link-text">{{ $t('sidebar.hr') }}</span>
      </template>
      <CNavItem>
        <router-link to="/users" class="nav-link">
          <span class="material-symbols-outlined nav-icon">people</span>
          <span class="link-text">{{ $t('sidebar.users_list') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/salary" class="nav-link">
          <span class="material-symbols-outlined nav-icon">shopping_cart_checkout</span>
          <span class="link-text">{{ $t('sidebar.salary') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/vacations/general" class="nav-link">
          <span class="material-symbols-outlined nav-icon">beach_access</span>
          <span class="link-text">{{ $t('sidebar.vacationsAndDaysOff') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/meetings/general" class="nav-link">
          <span class="material-symbols-outlined nav-icon">forum</span>
          <span class="link-text">{{ $t('sidebar.oneToOne') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/document-upload" class="nav-link">
          <span class="material-symbols-outlined nav-icon">upload_file</span>
          <span class="link-text">{{ $t('sidebar.documentUpload') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/onboarding-offboarding" class="nav-link">
          <span class="material-symbols-outlined nav-icon">person_add</span>
          <span class="link-text">{{ $t('sidebar.onboardingOffboarding') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/metrics" class="nav-link">
          <span class="material-symbols-outlined nav-icon">monitoring</span>
          <span class="link-text">{{ $t('sidebar.hrMetrics') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavGroup :visible="isOpenGroup(['/hr/jobcards/', '/hr/candidates/'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">work</span>
        <span class="link-text">{{ $t('sidebar.recruitment') }}</span>
      </template>
      <CNavItem>
        <router-link to="/hr/jobcards/" class="nav-link">
          <span class="material-symbols-outlined nav-icon">badge</span>
          <span class="link-text">{{ $t('sidebar.jobCards') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/hr/candidates/general" class="nav-link">
          <span class="material-symbols-outlined nav-icon">person_search</span>
          <span class="link-text">{{ $t('sidebar.candidates') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavGroup v-if="isReview" :visible="isOpenGroup(['/selfassessment', '/teamassessment', '/review360settings'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">content_paste</span>
        <span class="link-text">{{ $t('projectTeams.review360') }}</span>
      </template>
      <CNavItem>
        <router-link to="/selfassessment" class="nav-link">
          <span class="material-symbols-outlined nav-icon">person</span>
          <span class="link-text">{{ $t('review360.self') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/teamassessment" class="nav-link">
          <span class="material-symbols-outlined nav-icon">groups</span>
          <span class="link-text">{{ $t('review360.all') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/review360settings" class="nav-link">
          <span class="material-symbols-outlined nav-icon">settings</span>
          <span class="link-text">{{ $t('sidebar.settings') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavGroup :visible="isOpenGroup(['/userresults', '/teamresults'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">inventory</span>
        <span class="link-text">{{ $t('sidebar.results') }}</span>
      </template>
      <CNavItem>
        <router-link to="/userresults" class="nav-link">
          <span class="material-symbols-outlined nav-icon">assignment_ind</span>
          <span class="link-text">{{ $t('sidebar.self_results') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/teamresults" class="nav-link">
          <span class="material-symbols-outlined nav-icon">groups</span>
          <span class="link-text">{{ $t('results.teams') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>

    <CNavGroup :visible="isOpenGroup(['/legal-entity', '/types', '/roles', '/positions', '/document-types'])">
      <template #togglerContent>
        <span class="material-symbols-outlined nav-icon">tune</span>
        <span class="link-text">{{ $t('sidebar.systemSettings') }}</span>
      </template>
      <CNavGroup :visible="isOpenGroup(['/legal-entity', '/types'])">
        <template #togglerContent>
          <span class="material-symbols-outlined nav-icon">account_balance</span>
          <span class="link-text">{{ $t('sidebar.finance') }}</span>
        </template>
        <CNavItem>
          <router-link to="/legal-entity" class="nav-link">
            <span class="material-symbols-outlined nav-icon">gavel</span>
            <span class="link-text">{{ $t('sidebar.legalEntity') }}</span>
          </router-link>
        </CNavItem>
        <CNavItem>
          <router-link to="/types" class="nav-link">
            <span class="material-symbols-outlined nav-icon">request_quote</span>
            <span class="link-text">{{ $t('sidebar.types') }}</span>
          </router-link>
        </CNavItem>
      </CNavGroup>
      <CNavGroup :visible="isOpenGroup(['/leads-settings'])">
        <template #togglerContent>
          <span class="material-symbols-outlined nav-icon">person_add</span>
          <span class="link-text">Leads</span>
        </template>
        <CNavItem>
          <router-link to="/leads-settings" class="nav-link">
            <span class="material-symbols-outlined nav-icon">settings</span>
            <span class="link-text">Leads Settings</span>
          </router-link>
        </CNavItem>
      </CNavGroup>
      <CNavItem>
        <router-link to="/settings/general" class="nav-link">
          <span class="material-symbols-outlined nav-icon">orbit</span>
          <span class="link-text">{{ $t('sidebar.general') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/settings/onboarding" class="nav-link">
          <span class="material-symbols-outlined nav-icon">account_tree</span>
          <span class="link-text">{{ $t('sidebar.onboardingWorkflow') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/roles" class="nav-link">
          <span class="material-symbols-outlined nav-icon">admin_panel_settings</span>
          <span class="link-text">{{ $t('sidebar.role') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/positions" class="nav-link">
          <span class="material-symbols-outlined nav-icon">work</span>
          <span class="link-text">{{ $t('sidebar.position') }}</span>
        </router-link>
      </CNavItem>
      <CNavItem>
        <router-link to="/document-types" class="nav-link">
          <span class="material-symbols-outlined nav-icon">description</span>
          <span class="link-text">{{ $t('sidebar.documentTypes') }}</span>
        </router-link>
      </CNavItem>
    </CNavGroup>
  </CSidebarNav>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const isReview = computed(() => store.getters['teams/isReviewRunning'])

const isOpenGroup = (paths) => {
  const p = route.path
  return paths.some((x) => p.startsWith(x) || p.includes(x))
}
</script>

<style lang="scss">
@use '../../../styles/sidebar.scss' as *;

.sidebar-slider {
  .nav-group {
    .nav-group {
      padding-left: 0.5rem;

      > .nav-group-toggle {
        .nav-icon {
          opacity: 0.8;
          font-size: 18px;
        }
        .link-text {
          opacity: 0.9;
        }
      }
      .nav-link {
        padding-left: 2.25rem;
      }
    }
  }
}
</style>
